import { Warning, X } from "@phosphor-icons/react";
import GroupBadge from "@/components/GroupBadge";

const POSITION_ALERT_THRESHOLD = 6;

export default function PositionAlertModal({ accounts, onClose }) {
  if (!accounts?.length) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-[2px]"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="position-alert-title"
      data-testid="position-alert-modal"
    >
      <div className="position-alert-modal w-full max-w-lg border-2 bg-app-surface shadow-2xl">
        <div className="flex items-start justify-between gap-3 px-4 py-3 border-b border-[#FF3B30]/40 bg-[#FF3B30]/10">
          <div className="flex items-start gap-2 min-w-0">
            <Warning size={22} weight="fill" className="text-[#FF3B30] shrink-0 mt-0.5" />
            <div>
              <h2 id="position-alert-title" className="font-display font-bold text-base sm:text-lg text-[#FF3B30]">
                High position count
              </h2>
              <p className="font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mt-1">
                {accounts.length} account{accounts.length === 1 ? "" : "s"} with {POSITION_ALERT_THRESHOLD}+ open positions
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="btn-touch shrink-0 p-2 border border-app-border hover:bg-app-hover"
            aria-label="Dismiss alert"
            data-testid="position-alert-close"
          >
            <X size={16} weight="bold" />
          </button>
        </div>

        <ul className="max-h-[min(50vh,20rem)] overflow-y-auto divide-y divide-app-border/70">
          {accounts.map((acc) => {
            const accName = acc.account_name || acc.name || `Account #${acc.account_number || acc.id}`;
            return (
              <li key={acc.id} className="px-4 py-3 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    {acc.group ? <GroupBadge name={acc.group} color={acc.group_color} /> : null}
                    <span className="font-mono-d text-xs font-bold tabular-nums text-app-text">
                      #{acc.account_number || "—"}
                    </span>
                    {acc.broker ? (
                      <span className="text-[10px] font-mono-d text-app-subtle uppercase px-1.5 py-0.5 border border-app-border rounded">
                        {acc.broker}
                      </span>
                    ) : null}
                  </div>
                  <div className="text-sm font-semibold truncate text-app-text">{accName}</div>
                </div>
                <span className="font-mono-d text-lg font-bold tabular-nums text-[#FF3B30] shrink-0">
                  {acc.positions} pos
                </span>
              </li>
            );
          })}
        </ul>

        <div className="px-4 py-3 border-t border-app-border bg-app-bg/50">
          <button
            type="button"
            onClick={onClose}
            className="btn-touch w-full py-2.5 text-sm font-semibold bg-[#FF3B30] hover:bg-[#FF5C53] text-white"
          >
            Acknowledge & close
          </button>
        </div>
      </div>
    </div>
  );
}

export { POSITION_ALERT_THRESHOLD };
